import { useRoleContext } from "./useRoleContext";

export function useIsDemoParticipant(): boolean {
  const { company } = useRoleContext();
  return company?.is_demo_participant === true;
}
